import React, { Component, } from 'react';
import { bool, } from 'prop-types';
import styled from 'styled-components';
import { withRouter, } from 'react-router-dom';
import { connect, } from 'react-redux';

import { color, } from '../../../legacy-tv-dls';
import { USERS_MAP, } from '../../../constant';

// 富蘭克林投顧
const FooterCotainer = styled.footer`
  font-size: 14px;
  position: absolute;
  bottom: 15px;
  color: #888;
  padding-left: 20px;
  box-sizing: border-box;
  width: 100%;
  text-align: center;
`;
const Brand = styled.span`
  color: ${color.brand.primary['500']}
  margin-right: 3px
`;

export class Footer extends Component {
  static propTypes = {
    isAuth: bool,
  }
  static defaultProps = {
    isAuth: false,
  }
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const projectId = window.location.pathname.split('/')[1];
    return (
      <FooterCotainer>
        © 2018 <Brand>TradingValley</Brand>
        {
          this.props.isAuth && USERS_MAP[projectId] &&
          <span>本資料僅供於 {USERS_MAP[projectId].companyName} 參考使用</span>
        }
      </FooterCotainer>);
  }
}

function mapStateToProps(state) {
  return {
    isAuth: state.appState.isAuth,
  };
}

export default connect(mapStateToProps)(withRouter(Footer));



// WEBPACK FOOTER //
// ./src/components/global/Footer/index.js